import React from 'react';
import { Helmet } from 'react-helmet';

export const NEUTRAL_DIAGNOSTIC_HEADLINE = 'ASWB Exam Prep: Take the Free Diagnostic (LCSW, LMSW & LBSW)';

/**
 * What the build-time prerender paints for / and /try while the six-turn vs classic split is on (#785):
 * copy true for both arms, and an empty box as tall as either shell, so the client's arm swaps in without a flip.
 */
export const DiagnosticPrerender: React.FC<{
  canonicalPath: string;
  introPageTitle: string;
  metaDescription: string;
  belowSection?: React.ReactNode;
}> = ({ canonicalPath, introPageTitle, metaDescription, belowSection }) => (
  <div className="min-h-screen bg-neutral-50" data-testid="diagnostic-prerender">
    <Helmet>
      <title>{introPageTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={`https://www.socialworktestprepacademy.com${canonicalPath}`} />
    </Helmet>
    <div className="mx-auto max-w-2xl px-4 py-4 sm:py-12">
      <div className="mb-4 rounded-2xl bg-primary-500 shadow-ledge-brand px-5 py-5 sm:p-8 text-white">
        <p className="eyebrow text-primary-200 mb-2 sm:mb-3">Free · no account · reviewed by a practicing LCSW</p>
        <h1 className="font-display font-bold text-white text-[26px] sm:text-4xl leading-[1.1] mb-2 sm:mb-3">
          {NEUTRAL_DIAGNOSTIC_HEADLINE}
        </h1>
        <p className="text-primary-100 text-[15px] sm:text-base leading-snug">
          Questions reviewed by Pam Coin, LCSW. No account needed.
        </p>
      </div>
      <div className="min-h-screen" aria-hidden="true" />
      {belowSection}
    </div>
  </div>
);
